import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'normalize.css';
import './styles/styles.scss';
import App from './App';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);
